import { Autocomplete, Button } from "@mui/material";
import { useEffect, useState } from "react";
import { TextValidator } from "react-material-ui-form-validator";
import UserModal from "./UserModal";
import { postData } from "../Services/postData";
import { enumUrl, getRoles } from "../Utils/utils";
import style from "./Users.module.scss";
import Lang from "../Utils/lang";
import { v4 as uuidv4 } from "uuid";
import Checkbox from "@mui/material/Checkbox";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PropTypes from "prop-types";
import { updateData } from "../Services/updateData";

let lang = Lang.getInstance();
const roles = [
  { id: 1, label: "Administrator" },
  {
    id: 2,
    label: "Utilizator",
  },
];

function AddNewUser({
  selectedRow,
  handleCloseAddUserModal,
  setSelectedRow,
  onGetUsers,
  showAddUserModal,
  setLoading,
}) {
  const notifySuccess = (message) => toast.success(message);
  const notifyError = (message) => toast.error(message);
  const [user, setUser] = useState({
    name: "",
    username: "",
    email: "",
    role: {
      id: 2,
      label: "Utilizator",
    },
    isEdit: false,
    password: "",
    confirmPassword: "",
    errorText: "",
    lunchBreak: 0,
  });

  useEffect(() => {
    if (selectedRow) {
      setUser({
        name: selectedRow.name,
        username: selectedRow.username,
        role: getRoles(selectedRow.roles),
        isEdit: true,
        password: "",
        confirmPassword: "",
        errorText: "",
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedRow]);

  /**
   *
   * @param {*} event
   */
  function onChangeTextField(event) {
    const newUser = Object.assign({}, user);
    newUser[event.target.name] = event.target.value;
    setUser(newUser);
  }

  /**
   *
   */
  function generateCode() {
    let code = uuidv4();
    setUser({
      ...user,
      password: code.substr(0, 10),
      confirmPassword: code.substr(0, 10),
    });
  }

  /**
   *
   */
  function closeModal() {
    setUser({
      name: "",
      username: "",
      email: "",
      role: {
        id: 2,
        label: "Utilizator",
      },
      isEdit: false,
      password: "",
      confirmPassword: "",
      errorText: "",
    });
    handleCloseAddUserModal();
  }

  /**
   *
   * @param {*} event
   * @param {*} newValue
   */
  const handleChangeRole = (event, newValue) => {
    setUser({ ...user, role: newValue });
  };

  /**
   *
   * @returns
   */
  const handleAddUser = () => {
    if (user.password !== user.confirmPassword) {
      setUser({ ...user, errorText: lang.get("samePassword") });
      return;
    }
    setLoading(true);
    let data = {
      name: user.name,
      username: user.username,
      roles: [getRoles(user.role.id)],
      password: user.password,
    };
    if (selectedRow) {
      data.id = selectedRow.id;
      updateData(`${enumUrl.user}/${selectedRow.id}`, data)
        .then(async () => {
          setSelectedRow(null);
          closeModal();
          await onGetUsers();
          setLoading(false);
          notifySuccess(lang.get("successSaved"));
        })
        .catch((err) => {
          setLoading(false);
          notifyError(`${lang.get("errorSavingData")}: ${err}`);
        });
    } else {
      postData(enumUrl.register, data)
        .then(async () => {
          setSelectedRow(null);
          closeModal();
          await onGetUsers();
          setLoading(false);
          notifySuccess(lang.get("successSaved"));
        })
        .catch((err) => {
          setLoading(false);
          notifyError(`${lang.get("errorSavingData")}: ${err}`);
        });
    }
  };

  return (
    <UserModal
      open={showAddUserModal}
      handleClose={closeModal}
      title="Adăugați un utilizator nou"
      handleSubmit={handleAddUser}
      submitButton="Salvează"
      cancelButton="Anulează"
    >
      <TextValidator
        className={style.clientsList}
        label="Nume"
        name="name"
        type="text"
        validators={["required"]}
        errorMessages={[lang.get("required")]}
        value={user.name}
        onChange={(e) => onChangeTextField(e)}
      />
      <TextValidator
        className={style.clientsList}
        label="Nume utilizator"
        name="username"
        type="text"
        validators={["required"]}
        errorMessages={[lang.get("required")]}
        value={user.username}
        onChange={(e) => onChangeTextField(e)}
      />
      <Autocomplete
        className={style.clientsList}
        disableClearable
        disablePortal
        id="role"
        options={roles}
        value={user.role ? user.role.label : ""}
        renderInput={(params) => (
          <TextValidator {...params} label={lang.get("role")} />
        )}
        onChange={(event, newValue) => handleChangeRole(event, newValue)}
      />

      {selectedRow ? (
        <div style={{ display: "flex" }}>
          <Checkbox
            className={style.checkBox}
            checked={!user.isEdit}
            onChange={() => setUser({ ...user, isEdit: !user.isEdit })}
          />
          <p style={{ margin: 13 }}>Schimbați parola</p>
        </div>
      ) : (
        ""
      )}
      <TextValidator
        className={style.clientsList}
        label={lang.get("password")}
        name="password"
        type="text"
        validators={!user.isEdit ? ["required"] : ""}
        errorMessages={!user.isEdit ? [lang.get("required")] : ""}
        value={user.password}
        onChange={(e) => onChangeTextField(e)}
        disabled={user.isEdit}
        InputProps={{
          endAdornment: (
            <Button
              className={style.generateBtn}
              onClick={generateCode}
              fullWidth
              disabled={user.isEdit}
            >
              Generează
            </Button>
          ),
        }}
      />
      <TextValidator
        className={style.clientsList}
        label="Confirmați parola"
        name="confirmPassword"
        type="text"
        validators={!user.isEdit ? ["required"] : ""}
        errorMessages={!user.isEdit ? [lang.get("required")] : ""}
        value={user.confirmPassword}
        onChange={(e) => onChangeTextField(e)}
        disabled={user.isEdit}
      />
      <p style={{ margin: 10, color: "red" }}>{user.errorText}</p>
      <ToastContainer />
    </UserModal>
  );
}

AddNewUser.propTypes = {
  selectedRow: PropTypes.object,
  handleCloseAddUserModal: PropTypes.func,
  setSelectedRow: PropTypes.func,
  onGetUsers: PropTypes.func,
  showAddUserModal: PropTypes.bool,
  setLoading: PropTypes.func,
};
export default AddNewUser;
